import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import $script from 'scriptjs';

import Forms from '../Forms';
import layout from '../Layout';
import StickyHeader from '../components/StickyHeader';
import NavMobile from '../components/NavMobile';
import NavDesktop from '../components/NavDesktop';
import HeaderSearch from '../components/HeaderSearch';

export default class StaticSectionHeader {
  constructor(section) {
    this.$el = $(section.el);
    this.settings = section.data.settings;
    this.currency = section.data.currency;
    this.postMessage = section.postMessage;
    this.liveSearch = null;

    this.$menuToggle = this.$el.find('[data-menu-toggle]');
    this.$siteNavigation = this.$el.find('.site-navigation');
    this.$cartCount = this.$el.find('[data-header-cart-count]');
    this.$searchField = this.$el.find('[data-live-search]');
    this.$scripts = $('[data-scripts]');

    this.converter = '[data-currency-converter]';
    this.$converter = $(this.converter);

    this.stickyHeader = new StickyHeader({
      $el: this.$el,
      $toggle: this.$menuToggle,
      postMessage: this.postMessage,
    }, this.settings);

    this.navMobile = new NavMobile({
      $el: this.$el,
      $toggleOpen: this.$menuToggle,
    });

    this.navDesktop = new NavDesktop({
      $el: this.$siteNavigation,
      postMessage: this.postMessage,
    });

    this.forms = new Forms(this.$el);

    if (this.settings.live_search.enable) {
      $script(this.$scripts.data('shopify-api-url'), () => {
        this.liveSearch = new HeaderSearch({
          $el: this.$searchField,
          $header: this.$el,
        }, this.settings.live_search);
      });
    }

    if (this.currency.enable) {
      $script(this.$scripts.data('shopify-currencies'), () => {
        $script(this.$scripts.data('shopify-jquery-currencies'), () => {
          this._converter();
        });
      });
    }

    this.$el.on('cartcount:update', (event, data) => {
      this.$cartCount
        .attr('data-header-cart-count', data.response.item_count)
        .toggleClass('visible', data.response.item_count > 0);
    });
  }
  onSectionDeselect() {
    this.navDesktop.closeAll(null);
    this.stickyHeader.closeNavigation();
  }

  onSectionUnload() {
    this.stickyHeader.unload();
    this.navMobile.unload();
    this.navDesktop.unload();
    this.forms.unload();

    this.$el.off('cartcount:update');

    if(this.liveSearch) {
      this.liveSearch.unload();
    }

    if (this.currency.enable) {
      this.$converter.off('change.converter');
    }
  }

  onSectionBlockSelect(block) {
    if (layout.isBreakpoint('L')) {
      this.navDesktop.onSectionBlockSelect(block);
    }
  }

  onSectionMessage(name, data) {
    if (name === 'nav:close-all' && layout.isBreakpoint('L')) {
      this.navDesktop.closeAll(null);
    }

    if (name === 'stickyheader:open' && this.settings.sticky_header) {
      this.stickyHeader.openNavigation(true);
    }
  }

  _converter() {
    CurrencyConverter.init({
      switcherSelector: this.converter,
      priceSelector: '.money',
      shopCurrency: this.currency.shop_currency,
      defaultCurrency: this.currency.default_currency,
      displayFormat: this.currency.display_format,
      moneyFormat: this.currency.money_format,
      moneyFormatNoCurrency: this.currency.money_format_no_currency,
      moneyFormatCurrency: this.currency.money_format_currency,
    });

    this.$converter.on('change.converter', event => {
      this.$converter.each((index, converter) => {
        if (converter.value !== event.currentTarget.value) {
          converter.value = event.currentTarget.value;
        }
      });

      CurrencyConverter.setCurrency(event.currentTarget.value);
    });
  }
}
